export default {
  creditWallet: "المحفظة الائتمانية",
  creditLimit: "الحد الائتماني",
  usedCredit: "الائتمان المستخدم",
  available: "المتاح",
  creditDays: "أيام الائتمان",
  creditUsage: "استخدام الائتمان",
  outstandingOrders: "الطلبات المستحقة",
  paymentHistory: "سجل المدفوعات",
  order: "طلب",
  total: "الإجمالي",
  due: "المستحق",
  dueDate: "تاريخ الاستحقاق",
  status: "الحالة",
  settlementId: "رقم التسوية",
  ordersPaid: "الطلبات المدفوعة",
  amount: "المبلغ",
  mode: "الطريقة",
  date: "التاريخ",
  receipt: "الإيصال",
  view: "عرض",
  pdf: "PDF",
  close: "إغلاق",
  reset: "إعادة تعيين",
  rotate: "تدوير",
  download: "تحميل",
  paid: "مدفوع",
unpaid: "غير مدفوع",
partial: "جزئي",
overdue: "متأخر",
cash: "نقداً",
card: "بطاقة",
bank: "تحويل بنكي",
online: "أونلاين",
receiptPreview: "معاينة الإيصال",
receiptNotAvailable: "الإيصال غير متوفر",
unableDownloadPdf: "تعذر تنزيل ملف PDF",
searchOrder: "بحث الطلب",
};